import { IconProps } from '../iconProps';

export const UserRefresh = ({ size = 48 }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-refresh-ccw-user'
    >
      <path d='M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
      <path d='M3 3v5h4.5' />
      <path d='M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16' />
      <path d='M16 16h4.5v4.5' />

      <circle
        cx='12'
        cy='11'
        r='2'
        strokeWidth={2}
      />
      <path
        d='M8 17c0-1.25 4-2 4-2s4 .75 4 2'
        strokeWidth={2}
      />
    </svg>
  );
};
